import { render, staticRenderFns } from "./roleIndex.vue?vue&type=template&id=7a8efe5a&"
import script from "./roleIndex.vue?vue&type=script&lang=js&"
export * from "./roleIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports